<template>
  <div>
    <v-layout justify-center>
      <v-container fluid grid-list-md>
        <v-alert
          :value="showConnectionError"
          type="error"
        >Couldn't Connect to Post Service! Please Comeback Later!</v-alert>
        <v-layout row wrap>
          <v-flex md12 xs12 sm12>
            <v-card class="pa-2" flat>
              <v-layout row wrap>
                <v-flex xs12 md4 sm6>
                  <v-text-field
                    :hide-details="true"
                    v-model="filter.campaignName"
                    :height="56"
                    label="Filter by Campaign"
                    placeholder="Campaign Name"
                    outlined
                    v-on:keyup.enter="searchFilter"
                    v-if="currentUserRole === userRoles.INFLUENCER"
                  ></v-text-field>
                  <v-autocomplete
                    v-model="filter.campaignID"
                    item-value="id"
                    item-text="name"
                    :items="filterCampaigns"
                    label="Campaign Filter"
                    hide-details
                    outlined
                    auto-select-first
                    @change="searchFilter"
                    v-if="currentUserRole === userRoles.CLIENT"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4 sm6 v-if="currentUserRole !== userRoles.INFLUENCER">
                  <v-text-field
                    :hide-details="true"
                    v-model="filter.instagramHandle"
                    :height="56"
                    label="Filter by Instagram"
                    placeholder="Instagram Handle"
                    outlined
                    v-on:keyup.enter="searchFilter"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  md4
                  sm6
                  v-if="currentUserRole !== userRoles.INFLUENCER && currentUserRole !== userRoles.CLIENT"
                >
                  <v-select
                    :hide-details="true"
                    item-text="name"
                    item-value="id"
                    v-model="filter.clientID"
                    :items="clients"
                    :outlined="true"
                    label="Client"
                    placeholder="Select Client"
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs12 md2 sm6>
                    <v-checkbox color="secondary" v-model="filter.story" label="Show story types only"></v-checkbox>
                </v-flex>-->
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="resetFilter">Reset</v-btn>
                <v-btn @click="searchFilter" color="info" style="float: right">Filter</v-btn>
                <v-btn @click="openViewPostLayout()" color="warning" style="float: right">View All</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!showPostLayout">
          <v-flex xs12 sm12 md12 v-if="groupedPosts.length === 0">
            <div class="text-xs-center">
              <p>No record found!</p>
            </div>
          </v-flex>
          <!-- Post -->
          <v-expansion-panels>
            <v-expansion-panel v-for="(item,i) in groupedPosts" :key="i">
              <v-expansion-panel-header>
                <p class="ma-0 title" style="color: #3F3FFF">{{item._id.campaignName}}</p>
                <v-btn
                  style="max-width:120px;"
                  color="purple"
                  text
                  @click="openViewPostLayout(item._id.campaignName, item._id.campaignID, null)"
                >View Posts</v-btn>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <!-- Default Card -->
                  <v-col cols="12" sm="12" lg="3" md="4">
                    <v-hover>
                      <v-card
                        class="mx-auto"
                        max-width="250"
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                      >
                        <v-img
                          src="/static/img/upload-post-photo.png"
                          height="194px"
                          @click="openViewPostLayout(item._id.campaignName, item._id.campaignID, null)"
                          style="cursor: pointer"
                        ></v-img>

                        <v-card-actions>
                          <v-btn
                            color="purple"
                            text
                            @click="openViewPostLayout(item._id.campaignName, item._id.campaignID, null)"
                          >View All Posts</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-hover>
                  </v-col>
                  <!-- End Default Card -->
                  <v-col
                    cols="12"
                    md="4"
                    lg="3"
                    sm="12"
                    v-for="(inf, j) in item.influencers"
                    :key="j"
                  >
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        class="mx-auto"
                        max-width="250"
                        :elevation="hover ? 12 : 2"
                        v-if="inf.owner"
                      >
                        <!-- <v-img
                          :src="inf.owner.picture"
                          lazy-src="/static/img/avatar/user.png"
                          height="200px"
                        ></v-img> -->
                        <v-card-title>
                          <a
                            :href="'https://www.tiktok.com/@' + inf.owner.tiktokHandle"
                            target="_blank"
                            v-if="inf.owner.tiktokHandle"
                          ><img src="/static/img/tiktok-32.png" width="20px" /> @{{inf.owner.tiktokHandle}}</a>
                          <a
                            :href="'https://youtube.com/' + inf.owner.youtubeHandle"
                            target="_blank"
                            v-else-if="inf.owner.youtubeHandle"
                          ><v-icon>mdi-youtube</v-icon> @{{inf.owner.youtubeHandle}}</a>
                          <a
                            :href="'https://instagram.com/' + inf.owner.instagramHandle"
                            target="_blank"
                            v-else
                          ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{inf.owner.instagramHandle}}</a>
                        </v-card-title>

                        <v-card-subtitle>{{inf.noOfPosts}} {{inf.noOfPosts > 1 ? 'Posts' : 'Post'}}</v-card-subtitle>

                        <v-card-actions>
                          <!-- {{inf}} -->
                          <v-btn
                            color="purple"
                            text
                            @click="openViewPostLayout(item._id.campaignName, item._id.campaignID, inf.owner)"
                          >View Posts</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- View post per influencer -->

          <!-- Post -->
          <!-- pagination -->
          <!-- <v-flex xs2 md12 sm12 class="mt-3" v-if="posts.length > 0">
            <div class="text-xs-center">
              <v-pagination
                v-model="page"
                circle
                @input="pageChanged()"
                :value="pagging.page"
                :length="paginationLength"
              ></v-pagination>
            </div>
          </v-flex>-->
        </v-layout>
        <v-container transition="slide-x-transition" v-if="showPostLayout">
          <v-row>
            <v-col cols="6">
              <v-btn @click="closeViewPostLayout" color="secondary" tile outlined>
                <v-icon left>mdi-arrow-left</v-icon>Back
              </v-btn>
            </v-col>
            <v-col cols="6" align="right">
              <v-btn-toggle v-model="display" left mandatory :value="0" :light="true">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      <v-icon>list</v-icon>
                    </v-btn>
                  </template>
                  <span>List View</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      <v-icon>grid_on</v-icon>
                    </v-btn>
                  </template>
                  <span>Grid View</span>
                </v-tooltip>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row style="min-height: 500px;" transition="slide-x-transition" v-if="display === 1">
            <v-flex cols="12" sm="12" lg="12" md="12" v-if="posts.length === 0">
              <div class="text-xs-center">
                <p>No record found!</p>
              </div>
            </v-flex>
            <v-col cols="12" sm="12" lg="4" md="4" v-for="(post, index) of posts" :key="index">
              <v-hover>
                <!-- new card -->
                <v-card
                  class="mx-auto"
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                >
                  <v-list-item>
                    <!-- <v-list-item-avatar color="grey">
                      <img :src="paserImageUrl(post.author.picture)" alt="avatar" />
                    </v-list-item-avatar> -->
                    <v-list-item-content>
                      <v-list-item-title class="subtitle-1 ma-0">{{post.campaignName}}</v-list-item-title>
                      <v-list-item-subtitle class="caption font-italic">
                        By
                        <a
                          :href="'https://www.tiktok.com/@' + post.author.tiktokHandle"
                          target="_blank"
                          v-if="post.author.tiktokHandle"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{post.author.tiktokHandle}}</a>
                        <a
                          :href="'https://youtube.com/' + post.author.youtubeHandle"
                          target="_blank"
                          v-else-if="post.author.youtubeHandle"
                        ><v-icon>mdi-youtube</v-icon> @{{post.author.youtubeHandle}}</a>
                        <a
                          @click="openLink('https://www.xiaohongshu.com/user/profile/' + post.author.xhsHandle)"
                          v-else-if="post.author.xhsHandle"
                        >{{post.author.xhsHandle}}</a>
                        <a
                          :href="'https://www.linkedin.com/in/' + post.author.linkedinHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="post.author.linkedinHandle"
                        ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{post.author.linkedinHandle}}</a>
                        <a
                          :href="'https://x.com/' + getTwitterHandle(post)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="post.type === 'twitter' || post.author.twitterHandle"
                        ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{getTwitterHandle(post)}}</a>
                        <a
                          :href="'https://instagram.com/' + post.author.instagramHandle"
                          target="_blank"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{post.author.instagramHandle}}</a>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-img
                    v-if="!post.images[0]"
                    src="/static/img/upload-post-photo.png"
                    height="194px"
                    @click="viewDetailPost(post)"
                    style="cursor: pointer"
                  ></v-img>
                  <v-img
                    v-if="post.images[0] && !post.images[0].isvideo && !post.images[0].publicID"
                    :src="post.images[0].url"
                    height="194px"
                    @click="viewDetailPost(post)"
                    style="cursor: pointer"
                  ></v-img>
                  <div
                    class="post-cld-img cursor-pointer"
                    @click="viewDetailPost(post)"
                    v-if="post.images[0] && !post.images[0].isvideo && post.images[0].publicID">
                      <custom-media-v2
                        :media="campaignHelper.customPostMediaConfig(post.images[0], {})"
                      />
                  </div>
                  <video
                    v-if="post.images[0] && post.images[0].isvideo && !post.images[0].publicID"
                    height="194px"
                    width="100%"
                    @click="viewDetailPost(post)"
                    style="cursor: pointer"
                  >
                    <source :src="post.images[0].url" type="video/mp4" />Your browser does not support the video tag.
                  </video>
                  <div style="max-height: 200px;overflow: hidden;" v-if="post.images[0] && post.images[0].isvideo && post.images[0].publicID" @click="viewDetailPost(post)">
                    <custom-media-v2
                      :media="campaignHelper.customPostMediaConfig(post.images[0], { videoPreview: true })"
                    />
                  </div>

                  <v-card-text>
                    <div v-if="post.type !== 'post/carousel' && post.vdoLink " style="margin-top:10px;">
                        <v-btn
                          class="ma-0"
                          style="margin-top:5px !important;"
                          outlined
                          color="indigo"
                          target="_blank"
                          :href="post.vdoLink"
                          small
                        >
                          <v-icon left>mdi-link</v-icon>
                          Video Link
                        </v-btn>
                      </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-chip
                      v-for="label in post.labels"
                      :key="label.text"
                      class="ma-1"
                      small
                      :color="label.color"
                      :outlined="label.outlined"
                      :dark="label.dark"
                      @click="exec(label.action, post)"
                    >
                      <span v-if="label.faIcon">
                        <i :class="label.faIcon"></i>&nbsp;&nbsp;
                      </span>
                      {{label.text}}
                      <v-icon v-if="label.icon" right>{{label.icon}}</v-icon>
                    </v-chip>

                    <v-spacer></v-spacer>
                    <v-menu bottom right>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                          v-for="(menuItem, i) in menuOptions"
                          :key="i"
                          @click="actionPostBy(menuItem.action, post)"
                          v-if="showAvailableMenu(post, menuItem.action)"
                        >
                          <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                          <v-list-item-action>
                            <v-icon>{{menuItem.icon}}</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </v-card>
                <!-- new card -->
              </v-hover>
            </v-col>
          </v-row>
          <!-- display as list -->
          <v-layout row wrap v-if="display === 0">
            <v-flex md12 xs12 sm12>
              <v-toolbar flat color="white">
                <!-- <v-toolbar-title>Expandable Table</v-toolbar-title> -->
                <v-spacer></v-spacer>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" v-on="on">Bulk Action</v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(menuItem, i) in tableActions"
                      :key="i"
                      :disabled="menuItem.disabled"
                      @click="performSelected(menuItem.action)"
                    >
                      <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                      <!-- <v-list-tile-action>
                        <v-icon>{{menuItem.icon}}</v-icon>
                      </v-list-tile-action>-->
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-data-table
                item-key="_id"
                v-model="selected"
                :show-select="true"
                :server-items-length="totalItems"
                :options.sync="pagging"
                :headers="headers"
                :items="posts"
                :footer-props="{
                  itemsPerPageOptions: rowsPerPage
                  }"
                class="elevation-1"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item._id">
                      <td>
                        <v-checkbox
                          v-model="selected"
                          :checked="false"
                          :value="item"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>

                      <td class="text-xs-left">{{ item.campaignName }}</td>
                      <td class="text-xs-justify pa-1">
                        <a
                          :href="'https://www.tiktok.com/@' + item.author.tiktokHandle"
                          target="_blank"
                          v-if="item.author.tiktokHandle"
                        ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.author.tiktokHandle}}</a>
                        <a
                          :href="'https://youtube.com/' + item.author.youtubeHandle"
                          target="_blank"
                          v-else-if="item.author.youtubeHandle"
                        ><v-icon>mdi-youtube</v-icon> @{{item.author.youtubeHandle}}</a>
                        <a
                          :href="'https://www.linkedin.com/in/' + item.author.linkedinHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="item.author.linkedinHandle"
                        ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{item.author.linkedinHandle}}</a>
                        <a
                          :href="'https://x.com/' + getTwitterHandle(item)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="item.type === 'twitter' || item.author.twitterHandle"
                        ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{getTwitterHandle(item)}}</a>
                        <a
                          :href="'https://instagram.com/' + item.author.instagramHandle"
                          target="_blank"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.author.instagramHandle}}</a>
                      </td>
                      <td class="text-xs-left">
                        <div v-for="label in item.labels" :key="label.text">
                          <v-chip
                            class="ma-1"
                            small
                            :color="label.color"
                            :outlined="label.outlined"
                            :dark="label.dark"
                            @click="exec(label.action, item)"
                          >
                            <span v-if="label.faIcon">
                              <i :class="label.faIcon"></i>&nbsp;&nbsp;
                            </span>
                            {{label.text}}
                            <v-icon right>{{label.icon}}</v-icon>
                          </v-chip>
                        </div>
                        <div v-if="currentUserRole !== userRoles.INFLUENCER && item.postURL">
                          <!-- Show Post URL if URL is already there -->
                          <v-btn rounded small color="#F58529" :href="item.postURL" target="_blink">
                            View on
                            <v-icon right>mdi-instagram</v-icon>
                          </v-btn>
                        </div>
                      </td>
                      <td class="text-xs-left">{{ formatDate(item.createdAt, 'LLL')}}</td>
                      <td class="text-xs-left">
                        <v-menu bottom left>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on">
                              Actions
                              <v-icon right>mdi-menu</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item
                              v-for="(menuItem, i) in menuOptions"
                              :key="i"
                              @click="actionPostBy(menuItem.action, item)"
                              v-if="showAvailableMenu(item, menuItem.action)"
                            >
                              <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                              <v-list-item-action>
                                <v-icon>{{menuItem.icon}}</v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>

      </v-container>
    </v-layout>
    <view-post-modal
      v-model="viewPostDialog"
      :post="viewPostData"
      :csActions="showCsEditAction"
      :saleActions="showSaleAction"
      :clientActions="showClientEditAction"
      :influencerActions="showInfluencerEditAction"
      :cs_inf_chatbox="show_cs_inf_chatbox"
      :client_inf_chatbox="show_client_inf_chatbox"
      :postAbuseHistory="showPostAbuseHistory"
      :postReviewApproved="showPostReviewApproved"
      :postHistory="showPostHistory"
      :userObj="user"
      :value="viewPostDialog"
      @csApproved="csApproveFromView"
      @saleReleased="saleReleasePost"
      @editPost="editPostFromView"
      @mainPostChanged="reloadPostView"
    />
    <edit-post-modal
      v-model="editPostDialog"
      :post="editPostData"
      :postAbuseHistory="showPostAbuseHistory"
      @postUpdated="getPosts()"
      :value="editPostDialog"
      :userObj="user"
    />
    <assign-campaign-modal
      v-model="assignCampaignDialog"
      :post="assignCampaignPostData"
      @success="assignedCampaign($event)"
    />
    <map-influencer-modal
      v-model="mapInfluencerDialog"
      :post="mapInfluencerPostData"
      @successInfluencerMap="influencerMapSuccess($event)"
    />
    <submission-review-multiple-modal
      v-model="submissionReviewMultipleDialog"
      :posts="selected"
      :internalApprove="false"
      @successBulkApprove="getPosts()"
    />
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <add-post-to-campaign
      v-model="addPostToCampaign"
      :value="addPostToCampaign"
      :campaign="campaignDataForAddPost"
      :postID="postIdToUpdate"
      @done="postAdded"
    ></add-post-to-campaign>
    <change-post-status-modal
      v-model="changeStatusDialog"
      :post="postDataForChangeStatus"
      @updated="getPosts()"
    />
    <!-- client choose date modal -->
    <client-choose-date-modal
      :post="viewChooseDatePost"
      :ChooseDateDialogValue="chooseDateDialog"
      @chooseDateClosed="closeChooseDateModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import ViewPostModal from './ViewPostModal.vue';
import EditPostModal from './EditPost.vue';
import AssignCampaignModal from './AssignCampaignModal.vue';
import MapInfluencerModal from './MapInfluencerModal.vue';
import SubmissionReviewMultipleModal from './SubmissionReviewMultiple.vue';
import ClientChooseDateModal from './ClientChooseDateModal.vue';
import postConfig from './postConfig';
import PostAPI from './postApi';
import ClientAPI from '../Client/clientAPIs';
import Utils from '../../../utils';
import moment from 'moment';
import paymentAPIs from '../Influencer/paymentAPIs';
import AddPostToCampaign from '../../scoped/campaign/AddPostToCampaign';
import CampaignAPIs from '../Campaign/campaignAPIs';
import ChangePostStatusModal from './ChangePostStatusModal';
import campaignHelper from '../Campaign/campaignHelper';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import { platformDisplayName } from '@/utils/platformDisplay';

export default {
  name: 'Posts Index View',
  components: {
    ViewPostModal,
    AssignCampaignModal,
    MapInfluencerModal,
    EditPostModal,
    SubmissionReviewMultipleModal,
    AddPostToCampaign,
    ChangePostStatusModal,
    ClientChooseDateModal,
    CustomMediaV2
  },
  data() {
    return {
      posts: [],
      groupedPosts: [],
      rating: 3,
      viewChooseDatePost: {},
      filter: {
        instagramHandle: null,
        campaignName: null,
        campaignID: null,
        clientID: null,
        today: false,
        story: false
      },
      pagging: {
        page: 1,
        itemsPerPage: 6
      },
      postFilter: null,
      showPostLayout: false,
      totalItems: 0,
      instagramHandleList: [],
      clients: [],
      rowsPerPage: [6, 12, 18, 26, { text: 'All', value: -1 }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      viewPostDialog: false,
      editPostDialog: false,
      chooseDateDialog: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      submissionReviewMultipleDialog: false,
      showCsEditAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      show_client_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      showPostHistory: false,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      menuOptions: [],
      tableActions: [],
      selected: [],
      display: '',
      isFirstLoad: true,
      headers: [
        { text: 'Campaign', value: 'campaignName', sortable: true },
        { text: 'Influencer', value: 'submittedBy', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Submitted At', value: 'createdAt', sortable: true },
        { text: 'Actions', sortable: false }
      ],
      showConnectionError: false,
      loading: false,
      page: 1,
      addPostToCampaign: false,
      campaignDataForAddPost: null,
      postIdToUpdate: null,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      campaignHelper
    };
  },
  watch: {
    posts: function(newPosts) {
      var tmpArr = [];
      newPosts.forEach(post => {
        tmpArr.push(post.author.instagramHandle);
      });
      this.instagramHandleList = Array.from(new Set(tmpArr));
    },
    postStatus: function() {
      this.getPosts();
    },
    pagging: function(previous, after) {
      // This comparison is required the order in 2 obj is same
      if (JSON.stringify(previous) !== JSON.stringify(after)) {
        this.getPosts();
      }
    },
    selected: function() {
      this.validateTableActions(this.selected);
    },
    $route: function() {
      this.viewPostByRouter();
    }
  },
  methods: {
    getTwitterHandle(post) {
      const author = post.author || {}
      if (author.twitterHandle) return author.twitterHandle
      if (this.currentUserRole === config.userRoles.INFLUENCER && post.influencerID === this.user.influencerID) {
        if (this.user.twitterHandle) return this.user.twitterHandle
        const selectedPlatform = this.$store.state.showActivePlatform
        if (selectedPlatform && selectedPlatform.platform === 'twitter') {
          return selectedPlatform.handle.replace(/^@/, '')
        }
      }
      return author.instagramHandle || ''
    },
    openViewPostLayout(campaignName, campaignId, owner) {
      this.showPostLayout = true;
      let postFilter = {};
      if (campaignId) {
        postFilter.campaignId = campaignId;
      } else {
        this.filter.campaignID = null;
      }
      if (owner) {
        if (owner.tiktokHandle) {
          if (owner.tiktokHandle) {
            postFilter.tiktokHandle = owner.tiktokHandle;
          }
          if (owner.tiktokID) {
            postFilter.tiktokId = owner.tiktokID;
          }
        } else if (owner.youtubeHandle) {
          if (owner.youtubeHandle) {
            postFilter.youtubeHandle = owner.youtubeHandle;
          }
          if (owner.youtubeID) {
            postFilter.youtubeId = owner.youtubeID;
          }
        } else {
          if (owner.instagramHandle) {
            postFilter.instagramHandle = owner.instagramHandle;
          }
          if (owner.instagramID) {
            postFilter.instagramId = owner.instagramID;
          }
        }
      }
      this.postFilter = Object.assign({}, postFilter);
      this.getPosts();
    },
    closeViewPostLayout() {
      this.showPostLayout = false;
      this.posts = [];
      // Reset the filter to avoid the wrong parameters in the furture
      this.postFilter = null;
    },
    changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changeStatusDialog = true;
    },
    postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
    },
    bulkApprove() {
      if (this.selected.length > 0) {
        this.$swal({
          title: 'Terms and Agreements',
          html: `<p class="text-xs-left subtitle-1">Please note that the content creator reserves full creative rights to the final execution of the post and will only do 1 shoot based on the brief approved by the client. Drafts sent to clients for vetting are for the sole purpose of fact-checking and stylistic changes will not be allowed. The client is entitled to only 1 revision. </p>`,
          type: 'info',
          width: 500,
          backdrop: `rgba(0,0,1, 0.7)`,
          showCancelButton: true,
          confirmButtonText: 'Agree',
          cancelButtonText: 'Disagree',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.submissionReviewMultipleDialog = true;
          }
        })
      }
    },
    resetFilter() {
      this.filter = {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        today: false,
        story: false
      };
      this.getPosts();
    },
    assignedCampaign() {
      this.getPosts();
    },
    influencerMapSuccess() {
      this.getPosts();
    },
    validateTableActions(selected) {
      let disableApproveBtn = false;
      let disableReleaseBtn = false;
      if (!selected || selected.length === 0) {
        this.tableActions = this.tableActions.map(item => {
          item.disabled = true;
          return item;
        });
        return;
      }
      let disableAcceptBtn = false;
      for (let item of selected) {
        if (!item.campaignID || !item.postDate || item.waiting_release || item.status !== this.postStatusConfig.AD_STRATEGIST_PENDING) {
          disableApproveBtn = true;
        }
        if (!item.waiting_release) {
          disableReleaseBtn = true;
        }
        if (item.status !== this.postStatusConfig.CLIENT_PENDING) {
          disableAcceptBtn = true;
        }
      }
      for (let act of this.tableActions) {
        if (act.action === 'csApprove') {
          act.disabled = disableApproveBtn;
        } else if (act.action === 'saleApprove') {
          act.disabled = disableReleaseBtn;
        } else if (act.action === 'clientApprove') {
          act.disabled = disableAcceptBtn;
        }
      }
    },
    performSelected(action) {
      let ids = this.selected.map(item => item._id);
      switch (action) {
        case 'saleApprove':
          this.releasePosts(ids);
          break;
        case 'csApprove':
          this.approvePosts(ids);
          break;
        case 'clientApprove':
          this.bulkApprove();
          break;
      }
    },
    pageChanged() {
      this.pagging.page = this.page;
      this.getPosts();
    },
    isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      let tmpArr = clientReportArr.map(item => item.draftPostId);
      return tmpArr.includes(reportedDraftId);
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions() {
      let options = postConfig.menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else {
        this.menuOptions = options.filter(option => this.buttonShow(option.action));
      }
    },
    filterTableActions() {
      let options = postConfig.tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(option => this.buttonShow(option.action));
      }
      this.tableActions = this.tableActions.map(item => {
        item.disabled = true;
        return item;
      });
    },
    actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'clientApproveDate':
          this.openChooseDateDialog(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    // should be paginate posts (8 posts max at per page) to improve performance
    getPosts() {
      if (!this.postFilter) {
        return;
      }
      let status = this.postStatus;
      this.loading = true;
      let query = Utils.func.clean(this.postFilter);
      query.status = status;
      query.sortBy = this.pagging.sortBy && this.pagging.sortBy.length > 0 ? this.pagging.sortBy[0] : null
      query.descending = this.pagging.sortDesc && this.pagging.sortDesc.length > 0 ? this.pagging.sortDesc[0] : null
      PostAPI.getPost(query)
        .then(resp => {
          this.posts = [];
          this.selected = []; // Avoiding auto selection from data-table, this might be a bug from vuetify
          this.loading = false;
          this.showConnectionError = false;
          let posts = resp.posts;
          let totalItems = resp.totalItems;
          this.totalItems = totalItems;
          posts = posts.map(post => {
            // post.tags = Utils.func.extractHashTagsFromString(post.captionText);
            post.labels = this.getPostLabels(post);
            post.author = post.mapInfluencer || post.submitedBy || this.defaultPoster;
            return post;
          });
          if (query.tiktokHandle) {
            let handle = query.tiktokHandle
            posts = posts.filter(post => post.author && post.author.tiktokHandle === handle)
          }
          if (query.instagramHandle) {
            let handle = query.instagramHandle
            posts = posts.filter(post => post.author && post.author.instagramHandle === handle)
          }
          setTimeout(() => {
            this.posts = posts;
          }, 0)
          if (this.$route.query.postID) {
            let matchPost = posts.find(p => p._id === this.$route.query.postID)
            if (matchPost) {
              this.viewDetailPost(matchPost)
            }
          }
        })
        .catch(err => {
          this.showConnectionError = true;
          this.loading = false;
          console.error(err);
        });
      this.filterMenuOptions();
      this.filterTableActions();
    },
    getGroupedPosts() {
      let status = this.postStatus;
      this.loading = true;
      let query = Utils.func.clean(this.filter);
      query.status = status;
      this.posts = []
      // this.showPostLayout = false
      PostAPI.getGroupedPosts(query)
        .then(resp => {
          this.groupedPosts = [];
          this.selected = []; // Avoiding auto selection from data-table, this might be a bug from vuetify
          this.loading = false;
          this.showConnectionError = false;
          let groupedPosts = resp.posts;
          this.groupedPosts = groupedPosts;
        })
        .catch(err => {
          this.showConnectionError = true;
          this.loading = false;
          console.error(err);
        });
    },
    getClients() {
      ClientAPI.getAllClients().then(resp => {
        let clients = Object.assign([], resp.data);
        clients.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        this.clients = [{ name: 'All', id: null }, ...clients];
      });
    },
    reloadPostView(postData) {
      this.viewDetailPost(postData);
    },
    viewDetailPost(post) {
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST && !post.waiting_release) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.ACCOUNT_MANAGER && post.waiting_release) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status <= config.postStatus.APPROVE && this.currentUserRole === config.userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if (
        (this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.INFLUENCER) &&
        post.campaignID
      ) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if (this.currentUserRole === config.userRoles.CLIENT && post.campaignID) {
        this.show_client_inf_chatbox = true
      } else {
        this.show_client_inf_chatbox = false
      }
      if (post.clientReportAbuse && this.currentUserRole !== config.userRoles.INFLUENCER && post.status < config.postStatus.APPROVE) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === config.postStatus.APPROVE && this.currentUserRole !== config.userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id).then((post) => {
        this.viewPostData = post;
        this.$store.dispatch('post/updatePostViewUser', { postID: post._id })
        this.viewPostDialog = true;
      });
      // this.getPosts();
    },
    editPostFromView: function(post) {
      this.editPost(post);
    },
    exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    getPostLabels(post) {
      let labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING && this.currentUserRole <= this.userRoles.AD_STRATEGIST) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'secondary',
            action: 'viewDetailPost'
          });
        }
      }

      if (
        !post.waiting_release &&
        this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING &&
        this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW
      ) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING &&
      this.currentUserRole !== this.userRoles.INFLUENCER && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE &&
      this.currentUserRole !== this.userRoles.INFLUENCER && post.propose_dates) {
        labels.push({
          text: 'Propose Dates Available',
          icon: 'warning',
          outlined: true,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE && this.currentUserRole !== this.userRoles.INFLUENCER && post.requestDate && !post.propose_dates) {
        labels.push({
          text: 'Live Date Change Requested',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'secondary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING && this.currentUserRole !== this.userRoles.INFLUENCER && !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'black',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'primary',
              action: 'viewDetailPost'
            });
          }
        }
      }

      if (
        post.comments &&
        this.postStatus < this.postStatusConfig.APPROVE &&
        (this.currentUserRole === this.userRoles.INFLUENCER ||
        this.currentUserRole === this.userRoles.AD_STRATEGIST ||
        this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)
      ) {
        labels.push({
          text: `(${this.commentsInfo(post.comments)}) Comments`,
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.APPROVE) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: `${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: `Today - ${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER &&
      (this.postStatus === this.postStatusConfig.APPROVE || this.postStatus === this.postStatusConfig.LIVE)) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: platformDisplayName(post.type),
          color: 'primary',
          action: 'viewDetailPost'
        })
      }
      if (post.metadataTagged) {
        labels.push({
          text: 'Metadata Tagged',
          faIcon: 'fa fa-tag',
          color: 'blue',
          outlined: true,
          action: 'viewDetailPost'
        });
      }
      return labels;
    },
    editPost(post) {
      this.editPostData = Object.assign({}, post);
      // this.fetchPost(post._id).then((post) => {
      //   this.editPostData = Object.assign({}, post.mainPost);
      //   // console.log('Edit Post Data', post)
      // });
      this.editPostDialog = true;
      this.getPosts();
    },
    assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    paserImageUrl(url) {
      if (url) {
        var newUrl = url
          .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
          .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    csApproveFromView: function(post) {
      this.csApprovePost(post);
    },
    csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (!post.postDate) {
        this.$swal({
          title: 'Edit the post publishing date first before sending to client.',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from sale person.',
          type: 'info'
        });
      } else {
        let id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM person for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.approvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in approving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from sale person.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CS yet',
          type: 'warning'
        });
      } else {
        let id = post._id;
        this.releasePosts([id]);
      }
    },
    releasePosts(postIds) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releasePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-client' });
          this.getPosts();
          this.$emit('input');
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL(post) {
      CampaignAPIs.getCampaign(post.campaignID)
        .then(response => {
          this.campaignDataForAddPost = response;
          this.postIdToUpdate = post._id;
          this.addPostToCampaign = true;
        })
        .catch(err => {
          this.addPostToCampaign = true;
          this.$swal({
            type: 'error',
            title: 'Error Getting Campaign Information'
          });
          console.log(err);
        });
    },
    assignPostURL(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.publishPost(post._id, result.value)
            .then(() => {
              this.$swal({
                title: postConfirmationText['confirm']['title'],
                text: 'Do you want to submit payout?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
              }).then(confirmed => {
                if (confirmed.value) {
                  let payout = {
                    campaignName: post.campaignName,
                    campaignID: post.campaignID,
                    postID: post._id,
                    influencerID: post.influencerID,
                    instagramPostURL: result.value,
                    otherSocialMediaPostUrl: '',
                    satisfactionLevel: 0,
                    advertiserSatisfactionLevel: 0
                  };
                  paymentAPIs
                    .createCampaignPayout(payout)
                    .then(() => {
                      this.$swal({
                        type: 'success',
                        title: 'Campaign payout created!'
                      });
                    })
                    .catch(() => {
                      this.$swal({
                        type: 'error',
                        title: 'Cannot create campaign payout for this post. Try again later!'
                      });
                    });
                }
              });
              this.getPosts();
              // this.$router.push({ path: '/posts/published' });
            })
            .catch(() => {
              this.$swal({
                type: 'error',
                title: 'Error in processing your request! Please try again'
              });
            });
        }
      });
    },
    completePost(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.completePost(post._id)
            .then(() => {
              this.$swal({
                type: 'success',
                title: postConfirmationText['confirm']['title'],
                text: postConfirmationText['confirm']['text']
              }).then(() => {
                this.getPosts();
                // this.$router.push({ path: '/posts/completed' });
              });
            })
            .catch(error =>
              this.$swal({
                type: 'error',
                text: error
              })
            );
        }
      });
    },
    formatDate(date, format = 'll') {
      return moment(date).format(format);
    },
    checkAfter(date) {
      return moment(this.currentDate).isAfter(date);
    },
    checkSame(date) {
      return moment(this.currentDate).isSame(date);
    },
    fetchPost(postId, returnData) {
      return new Promise((resolve, reject) => {
        PostAPI.getPostById(postId)
        .then(post => {
          // this.viewPostData = post;
          resolve(post)
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
          reject(err);
        });
      })
    },
    commentsInfo(comments) {
      if (comments === undefined) {
        return;
      } else {
        let commentsArr = comments.filter(comment => comment.author.id !== this.user.id);
        return commentsArr.length;
      }
    },
    viewPostByRouter() {
      // look for query parameters action for view and id to initiate the postView
      let action = this.$route.query.action;
      let id = this.$route.query.id;
      if (action === 'view' && id) {
        PostAPI.getPostById(id)
          .then(post => {
            this.viewDetailPost(post);
          })
          .catch(err => {
            this.$swal({
              title: `Couldn't the Post`,
              type: 'error',
              text: err
            });
          });
      } else {
        this.LoadPosts()
      }
    },
    async LoadPosts() {
      if (this.currentUserRole !== this.userRoles.CLIENT && this.currentUserRole !== this.userRoles.INFLUENCER) {
        this.getClients();
        this.getGroupedPosts();
        this.openViewPostLayout();
        this.viewPostByRouter();
      } else {
        this.getGroupedPosts();
        this.openViewPostLayout();
        if (this.currentUserRole === this.userRoles.CLIENT) {
          await this.$store.dispatch('campaign/getCampaigns', {
            filters: {
              clientID: this.user.clientID
            }
          })
          this.filterCampaigns = Object.assign([], this.campaigns)
          this.filterCampaigns.unshift({id: '', name: 'All Campaigns'})
        }
      }
    },
    searchFilter() {
      if (!this.showPostLayout) {
        this.getGroupedPosts()
      } else {
        this.openViewPostLayout(null, this.filter.campaignID, this.filter)
      }
    },
    showAvailableMenu(post, action) {
      if (this.currentUserRole === this.userRoles.CLIENT) {
        if (action === 'clientReview' &&
        post.status === this.postStatusConfig.CLIENT_PENDING &&
        post.propose_dates) {
          return false
        }
        if (action === 'clientApproveDate' &&
        post.status === this.postStatusConfig.APPROVE &&
        !post.propose_dates) {
          return false
        }
      }
      return true
    },
    openChooseDateDialog(post) {
      this.viewChooseDatePost = post
      this.chooseDateDialog = true
    },
    closeChooseDateModal() {
      this.chooseDateDialog = false
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns
    }),
    user: function() {
      return this.$store.state.user;
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function() {
      return this.$route.meta.postStatus;
    },
    userRoles: function() {
      return config.userRoles;
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    currentDate: function() {
      return moment().format('ll');
    },
    paginationLength: function() {
      let round = this.totalItems / this.pagging.itemsPerPage;
      let decimal = this.totalItems % this.pagging.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    }
  },
  mounted() {
    this.LoadPosts()
    if (this.currentUserRole === config.userRoles.CLIENT) {
      this.display = 0
    } else {
      this.display = 1
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?127461d2